import React from "react";
import { Dialog } from "@headlessui/react";
import { MdClose } from "react-icons/md";

const AddressModal = ({ isOpen, onClose, address, landlordName, landlordPan }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="fixed inset-0 z-50 overflow-y-auto"
    >
      <div className="flex min-h-screen items-center justify-center p-4">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-50" />

        <div className="relative bg-white rounded-lg max-w-md w-full">
          <div className="flex items-center justify-between p-4 border-b">
            <Dialog.Title className="text-lg font-medium">
              Rental Address
            </Dialog.Title>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <MdClose className="w-6 h-6" />
            </button>
          </div>

          <div className="p-6 space-y-4">
            <div>
              <p className="text-sm text-gray-600 mb-1">Address</p>
              <p className="text-base text-gray-900">{address || "--"}</p>
            </div>
            <div>
              <p className="text-sm text-gray-600 mb-1">Landlord Name</p>
              <p className="text-base text-gray-900">{landlordName || "--"}</p>
            </div>
            <div>
              <p className="text-sm text-gray-600 mb-1">Landlord PAN</p>
              <p className="text-base text-gray-900">{landlordPan || "--"}</p>
            </div>
          </div>

          <div className="flex justify-end p-4 border-t">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AddressModal;
